export const sponsoring = {
  bannerTitle: 'BÜHNE FREI FÜR IHRE MARKE!',
  bannerText: 'Platzieren Sie Ihr Angebot bei Immobilieneigentümer zum richtigen Zeitpunkt',
  buttonText: 'Informationen einholen',
  presentTitle: 'So können Sie Ihr Angebot präsentieren',
  presentTitle1: 'Ihr Ratgeberartikel auf HausHeld.ch',
  presentTitle2: 'Gezieltes Targetmailing',
  presentTitle3: 'Verknüpfung auf Branchenseite',
  presentText1:
    'Inhaltliches Marketing mit einem freiwählbaren Thema inkl. SEO-relevanter Verlinkung auf Ihre Website. <br />Jahrespauschale: CHF 1&apos;800',
  presentText2:
    'Verlinkung zum Ratgeberartikel bei der E-Mail-Korrespondenz. <br />Jahrespauschale: CHF 1&apos;200',
  presentText3:
    'Kurzdarstellung inkl. Verlinkung zum Ratgeberartikel bei passenden Branchenseiten. <br />Jahrespauschale: CHF 1&apos;200',
  advantageTitle: 'Von unschlagbaren Vorteilen profitieren',
  advantageSubtitle:
    'Immobilieneigentümer finden über HausHeld passende Handwerksbetriebe und informieren sich über spannende Themen Rund ums Eigenheim. Platzieren Sie Ihre Innovationen in Ihrem eigenen Ratgeberartikel und profitieren Sie von der Endkundenansprache zum perfekten Zeitpunkt.',
  advantageTitle1: 'Lukrative Zielgruppe',
  advantageText1:
    'HausHeld empfängt jährlich über 500&apos;000 renovationsinteressierte Haus- und Stockwerkeigentümer.',
  advantageTitle2: 'Richtiger Moment',
  advantageText2:
    'Auf HausHeld können Sie sich genau beim entscheidungsfindenden Moment des Endkunden wirksam positionieren.',
  advantageTitle3: 'Ihr spannendes Thema',
  advantageText3:
    'Im Ratgeber können Sie freiwählbar Ihr spannendes Thema beim Endkunden platzieren.',
  targetingTitle: 'Lukrative Zielgruppen erstklassig ansprechen!',
  targetingSubtitle:
    'Auf dem Renovationsportal HausHeld.ch können Haus- und Stockwerkeigentümer Renovationswünsche aller Art äussern. HausHeld.ch hilft beim Finden der richtigen Partner und berät den Eigentümer zu spannenden Themen.',
  targetingTitle1: 'Überzeugen durch Content',
  targetingText1:
    'Als hochwertiger Content Partner überzeugen Sie relevante Zielgruppen mit einem spannenden Thema',
  targetingTitle2: 'Zur rechten Zeit am rechten Ort',
  targetingText2:
    'Eigentümer planen Renovationen und informieren sich in unserem Ratgeber über Ihr Thema',
  targetingTitle3: 'Ihr Ratgeber - Ihr Endkundenkanal',
  targetingText3:
    'Profitieren Sie von zusätzlichem Kaufinteresse bei renovationsinteressierten Eigentümern',
  formTitle: 'Jetzt Ratgeber veröffentlichen und von gezieltem Marketing profitieren!',
  formSubtitle: 'Wir beraten Sie gerne. Füllen Sie dafür einfach das Kontaktformular aus.',
  subject: 'Thema',
  faqQuestion1: 'Welche Kosten kommen auf mich zu?',
  faqQuestion2: 'Wer sieht meinen Ratgeberartikel?',
  faqQuestion3: 'Welche Inhalte darf ich platzieren?',
  faqQuestion4: 'Habe ich zusätzliche Optionen',
  faqAnswer1:
    'Für einen individuellen Ratgeberartikel inkl. SEO-relevanten Verknüpfungen auf Ihre Website, wird eine Jahrespauschale von CHF 1&apos;800 fällig.',
  faqAnswer2:
    'Die Ratgeber-Artikel werden von sämtlichen renovationsinteressierten Haus- und Stockwerkeigentümer gesehen, welche auf HausHeld.ch kommen.',
  faqAnswer3:
    'Die Inhalte können freiwählbar platziert werden, müssen aber mehrwertstiftend für den Kunden sein, um das Thema Haus und Wohnung handeln und dürfen nicht mit einem vermittelten Gewerk direkt konkurrenzieren.',
  faqAnswer4:
    'Ihr Ratgeberartikel kann bei Ihren Zielkunden zusätzlich platziert werden. Dazu haben Sie folgende Möglichkeiten: <br /><ul><li>Zusätzliche Reichweite mit Targetmailing (Jahrespauschale CHF 1&apos;200)</li><li>Verknüpfung auf eine Branchenseite (Jahrespauschale CHF 1&apos;200)</li></ul>',
  successToast: 'Ratgeber-Anfrage wurde erfolgreich versendet',
}
